/* FugaX (15/10/2026) · interações da PDP (template product.fuga).
   Avaliações das 6 cores (Judge.me, widget público), preço espelhado do bloco principal, cores, cashback,
   ?variant=, botão com data de chegada, barra fixa, vídeo do anúncio na galeria e "Combina com". */
(function () {
  if (window.mbFxInit) return;
  window.mbFxInit = true;

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var brl = function (c) { return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(c / 100); };
  var cents = function (t) { var m = String(t || '').match(/R\$\s?([\d.]+,\d{2})/); return m ? Number(m[1].replace(/\./g, '').replace(',', '')) : 0; };
  function f1(v) { return (Math.round(v * 10) / 10).toFixed(1).replace('.', ','); }
  function joinPt(list) { return list.length < 2 ? list.join('') : list.slice(0, -1).join(', ') + ' e ' + list[list.length - 1]; }

  /* ---------- avaliações (6 cores) ---------- */
  var ENDPOINT = 'https://judge.me/reviews/reviews_for_widget';
  var PER_PAGE = 50, MAX_PAGES = 6, cache = null;
  function parseItems(raw) {
    return String(raw || '').split('|').filter(Boolean).map(function (s) { var p = s.split('~'); return { id: p[0], cor: p[1] || '' }; });
  }
  function fetchPage(shop, item, page) {
    var q = new URLSearchParams({ url: shop, shop_domain: shop, platform: 'shopify', product_id: item.id, per_page: String(PER_PAGE), page: String(page) });
    return fetch(ENDPOINT + '?' + q.toString(), { credentials: 'omit' }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
  }
  function fetchOne(shop, item) {
    var acc = [];
    function next(page) {
      return fetchPage(shop, item, page).then(function (d) {
        var got = (d && d.reviews) || [];
        acc = acc.concat(got);
        if (got.length === PER_PAGE && page < MAX_PAGES) return next(page + 1);
        return acc;
      });
    }
    return next(1).then(function (list) {
      return list.map(function (r) {
        var doc = new DOMParser().parseFromString(String(r.body_html || ''), 'text/html');
        return { cor: item.cor, pid: item.id, nota: Number(r.rating) || 0, titulo: (r.title || '').trim(), texto: (doc.body.textContent || '').trim(),
          data: String(r.created_at || '').slice(0, 10), verificado: !!r.verified_buyer, inicial: r.reviewer_initial || '' };
      });
    });
  }
  function loadAll(shop, items) {
    if (cache) return cache;
    cache = Promise.all(items.map(function (it) { return fetchOne(shop, it); })).then(function (parts) {
      var seen = {}, all = [];
      parts.forEach(function (list) { list.forEach(function (r) {
        if (!r.texto) { all.push(r); return; }
        var k = r.texto.toLowerCase() + '|' + r.data; if (!seen[k]) { seen[k] = 1; all.push(r); }
      }); });
      return all;
    });
    return cache;
  }
  function stats(all) {
    var n = all.length, sum = 0, ok = 0, hist = { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 };
    all.forEach(function (r) { sum += r.nota; if (r.nota >= 4) ok += 1; if (hist[r.nota] != null) hist[r.nota] += 1; });
    return { n: n, avg: n ? sum / n : 0, pct: n ? Math.round(ok / n * 100) : 0, hist: hist };
  }
  var ratingRoot = $('[data-mb-fx-rating]');
  var reviewsP = ratingRoot ? loadAll(ratingRoot.dataset.shop, parseItems(ratingRoot.dataset.items)) : null;

  if (ratingRoot && reviewsP) {
    reviewsP.then(function (all) {
      var s = stats(all);
      if (!s.n) return;
      ratingRoot.querySelector('[data-avg]').textContent = f1(s.avg);
      ratingRoot.querySelector('[data-count]').textContent = s.n;
      $$('[data-count-w]', ratingRoot).forEach(function (w) { w.textContent = s.n === 1 ? 'avaliação' : 'avaliações'; });
      ratingRoot.querySelector('[data-count-wrap]').hidden = false;
      ratingRoot.querySelector('[data-pct-n]').textContent = s.pct + '%';
      ratingRoot.querySelector('[data-pct]').hidden = false;
    });
  }

  /* ---------- seção de avaliações ---------- */
  $$('[data-mb-fx-reviews]').forEach(function (root) {
    var items = parseItems(root.dataset.items);
    var current = root.dataset.current;
    var state = { f: 'all', n: matchMedia('(max-width:900px)').matches ? 2 : 6, all: [] };
    var list = root.querySelector('[data-list]'), more = root.querySelector('[data-more]');
    function render() {
      var L = state.all.slice().sort(function (a, b) { return (b.pid === current) - (a.pid === current) || b.data.localeCompare(a.data); });
      if (state.f === 'this') L = L.filter(function (r) { return r.pid === current; });
      if (state.f === 'crit') L = L.filter(function (r) { return r.nota <= 4; });
      list.replaceChildren();
      L.slice(0, state.n).forEach(function (r) {
        var a = document.createElement('article'); a.className = 'mb-fx-rv' + (r.pid === current ? ' this' : '');
        var st = document.createElement('div'); st.className = 'mb-fx-rv-s'; st.setAttribute('aria-label', 'Nota ' + r.nota + ' de 5');
        st.textContent = '★★★★★'.slice(0, r.nota) + '☆☆☆☆☆'.slice(0, 5 - r.nota); a.append(st);
        if (r.titulo) { var h = document.createElement('h3'); h.textContent = r.titulo; a.append(h); }
        var p = document.createElement('p'); p.textContent = r.texto; a.append(p);
        var m = document.createElement('div'); m.className = 'mb-fx-rv-m';
        m.textContent = (r.inicial ? r.inicial + '. · ' : '') + 'cor ' + r.cor + ' · ' + r.data.split('-').reverse().join('/') + (r.verificado ? ' · compra verificada' : '');
        a.append(m); list.append(a);
      });
      more.hidden = L.length <= state.n;
    }
    root.querySelectorAll('[data-f]').forEach(function (b) {
      b.addEventListener('click', function () {
        state.f = b.dataset.f; state.n = 6;
        root.querySelectorAll('[data-f]').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        render();
      });
    });
    more.addEventListener('click', function () { state.n += 8; render(); });
    loadAll(root.dataset.shop, items).then(function (all) {
      state.all = all;
      var s = stats(all);
      if (!s.n) { root.querySelector('[data-empty]').hidden = false; return; }
      root.querySelector('[data-avg]').textContent = f1(s.avg);
      root.querySelector('[data-count]').textContent = s.n;
      $$('[data-count-w]', root).forEach(function (w) { w.textContent = s.n === 1 ? 'avaliação' : 'avaliações'; });
      root.querySelector('[data-pct]').textContent = s.pct + '%';
      var mine = all.filter(function (r) { return r.pid === current; });
      root.querySelector('[data-this]').textContent = mine.length
        ? mine.length + ' desta cor (nota ' + f1(mine.reduce(function (x, r) { return x + r.nota; }, 0) / mine.length) + ').'
        : 'Esta cor ainda não tem avaliação.';
      var hist = root.querySelector('[data-hist]');
      hist.replaceChildren();
      [5, 4, 3, 2, 1].forEach(function (k) {
        var row = document.createElement('div');
        var bar = document.createElement('i'); var fill = document.createElement('b'); fill.style.width = (s.hist[k] / s.n * 100).toFixed(1) + '%'; bar.append(fill);
        var a = document.createElement('span'); a.textContent = k + '★'; var c = document.createElement('span'); c.textContent = s.hist[k];
        row.append(a, bar, c); hist.append(row);
      });
      root.querySelector('[data-body]').hidden = false;
      render();
    });
  });

  /* ---------- preço espelhado do bloco principal (variante, live, Super Black) ---------- */
  var info = $('.pdp-info');
  var priceSrc = info && $('.pdp-price [data-price]', info);
  var pixSrc = info && $('[data-pix]', info);
  var instSrc = info && $('[data-inst]', info);
  function syncPrice() {
    if (!priceSrc) return;
    var p = cents(priceSrc.textContent);
    var pixShown = pixSrc && !pixSrc.hidden && cents(pixSrc.textContent);
    $$('[data-mb-fx-pmobile]').forEach(function (box) {
      var a = $('[data-mb-fx-p]', box), b = $('[data-mb-fx-pix]', box), c = $('[data-mb-fx-inst]', box);
      if (a) a.textContent = priceSrc.textContent.trim();
      if (b) { b.hidden = !pixShown; if (pixShown) b.textContent = 'Pix ' + brl(pixShown); }
      if (c && instSrc) { var ic = cents(instSrc.textContent); if (ic) c.textContent = 'ou 8x de ' + brl(ic); }
    });
    $$('[data-mb-fx-first]').forEach(function (el) { if (p) el.textContent = brl(Math.round(p * 0.9)); });
    $$('[data-mb-fx-sticky-pix]').forEach(function (el) { el.hidden = !pixShown; if (pixShown) el.textContent = 'Pix ' + brl(pixShown); });
    $$('[data-mb-fx-sbar]').forEach(function (bar) {
      var b = $('[data-mb-fx-sbar-pix]', bar), c = $('[data-mb-fx-sbar-inst]', bar);
      if (b && (pixShown || p)) {
        var sm = document.createElement('small'); sm.textContent = pixShown ? 'no Pix' : '';
        b.replaceChildren(document.createTextNode(brl(pixShown || p) + ' '), sm);
      }
      if (c && instSrc) { var ic = cents(instSrc.textContent); if (ic) c.textContent = 'ou 8x de ' + brl(ic); }
    });
    if (p) document.dispatchEvent(new CustomEvent('mb-fx:price', { detail: { cents: p } }));
  }
  if (priceSrc) {
    var mo = new MutationObserver(syncPrice);
    [priceSrc, pixSrc, instSrc].forEach(function (n) { if (n) mo.observe(n, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['hidden'] }); });
  }

  /* ---------- "Onde você vai usar?" ---------- */
  $$('[data-mb-fx-uses]').forEach(function (root) {
    var chips = $$('.mb-fx-chip', root), boxes = $$('.mb-fx-usebox', root);
    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        chips.forEach(function (x) { x.setAttribute('aria-pressed', String(x === c)); });
        boxes.forEach(function (b) { b.hidden = b.dataset.box !== c.dataset.i; });
      });
    });
  });

  /* ---------- cores: preço, nota e esgotados de cada cor ---------- */
  $$('[data-mb-fx-colors]').forEach(function (root) {
    var handles = String(root.dataset.handles || '').split(',').filter(Boolean);
    var current = root.dataset.current;
    var note = $('[data-colornote]', root), pnote = $('[data-pricenote]', root);
    var model = root.dataset.model || 'FugaX 01';
    /* 22/10: "Mergulhão 05A Preto" com modelo "Mergulhão 05" vira "05A Preto" (versão colada ao número) */
    var colorName = function (title) { var t = String(title || ''); var i = t.indexOf(model); if (i < 0) return t; var r = t.slice(i + model.length); return (/^\S/.test(r) ? model.split(' ').pop() + r : r).trim(); };
    Promise.all(handles.map(function (h) {
      return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (prods) {
      var data = {};
      prods.forEach(function (p, i) {
        if (!p) return;
        data[handles[i]] = { cor: colorName(p.title), price: p.price, url: p.url || ('/products/' + handles[i]), img: p.featured_image || '', title: p.title,
          out: (p.variants || []).filter(function (v) { return !v.available; }).map(function (v) { return v.option1 || v.title; }) };
      });
      var groups = {};
      handles.forEach(function (h) { if (data[h]) { (groups[data[h].price] = groups[data[h].price] || []).push(data[h].cor); } });
      var keys = Object.keys(groups).map(Number).sort(function (a, b) { return a - b; });
      if (pnote && keys.length > 1) pnote.textContent = keys.map(function (k) { return joinPt(groups[k]) + ' por ' + brl(k); }).join('. ') + '.';
      var ratingByCor = {};
      (reviewsP || Promise.resolve([])).then(function (all) {
        all.forEach(function (r) { var x = ratingByCor[r.cor] = ratingByCor[r.cor] || { n: 0, s: 0 }; x.n += 1; x.s += r.nota; });
      }).then(function () {
        function infoFor(h) {
          var d = data[h]; if (!d) return '';
          var r = ratingByCor[d.cor];
          return d.cor + ' · ' + brl(d.price) + (r ? ' · ★ ' + f1(r.s / r.n) + ' (' + r.n + ')' : ' · sem avaliação') + (d.out.length ? ' · ' + d.out.length + ' números esgotados (' + d.out.join(', ') + ')' : '');
        }
        function decorate() {
          var row = $('[data-siblings-row]'); if (!row) return;
          var links = $$('a', row);
          if (!links.length) return;
          /* completa as cores que a rota do tema não trouxe (produto sem a tag do modelo) */
          var have = links.map(function (a) { return (a.getAttribute('href') || '').split('?')[0].replace(/\/+$/, '').split('/').pop(); });
          handles.forEach(function (h) {
            var d = data[h]; if (!d || have.indexOf(h) !== -1 || !d.img) return;
            var a = document.createElement('a'); a.href = d.url; a.title = d.title;
            var im = document.createElement('img'); var src = String(d.img); if (src.indexOf('//') === 0) src = 'https:' + src;
            im.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=200'; im.alt = d.title; im.loading = 'lazy';
            a.append(im); row.append(a);
          });
          links = $$('a', row);
          var label = $('.pdp-sibs-label'); if (label) { var sp = $('.mb-fx-sibcount', label); if (!sp) { sp = document.createElement('span'); sp.className = 'mb-fx-sibcount'; label.append(sp); } sp.textContent = ' · ' + links.length + ' cores'; }
          links.forEach(function (a) {
            if (a.dataset.mbFx) return;
            var h = (a.getAttribute('href') || '').split('?')[0].replace(/\/+$/, '').split('/').pop();
            var d = data[h];
            /* 22/10: variante do mesmo modelo fora da lista (ex.: Mergulhão 05A) mostra só "05A Preto", não o título inteiro */
            if (!d) { var base = model.split(' ')[0], tt = a.title || '', k = tt.indexOf(base); if (k >= 0) { a.title = tt.slice(k + base.length).trim(); a.setAttribute('aria-label', 'Cor ' + a.title); } return; }
            a.dataset.mbFx = '1';
            var pr = document.createElement('span'); pr.className = 'mb-fx-swp'; pr.textContent = brl(d.price).replace(',00', ''); a.append(pr);
            /* 22/10 (Gabriel): só o nome da cor; sem avaliação e sem números esgotados (não expor estoque) */
            a.setAttribute('aria-label', 'Cor ' + d.cor); a.title = d.cor;
          });
        }
        decorate();
        var row = $('[data-siblings-row]'); if (row) new MutationObserver(decorate).observe(row, { childList: true });
      });
    });
  });

  /* ---------- cashback com regra (só se a campanha estiver ativa no tema) ---------- */
  $$('[data-mb-fx-cash]').forEach(function (mine) {
    var theirs = $('[data-pdp-cashback]');
    function sync() { var on = !!theirs && !theirs.hidden; mine.hidden = !on; if (theirs) theirs.classList.add('mb-fx-hide'); }
    sync();
    if (theirs) new MutationObserver(sync).observe(theirs, { attributes: true, attributeFilter: ['hidden'] });
  });

  /* ---------- diálogos e link das condições ---------- */
  document.addEventListener('click', function (e) {
    var op = e.target.closest('[data-mb-fx-open]');
    if (op) { var d = document.getElementById(op.dataset.mbFxOpen); if (d && d.showModal) d.showModal(); return; }
    var cl = e.target.closest('[data-mb-fx-close]');
    if (cl) { cl.closest('dialog').close(); return; }
    if (e.target.matches && e.target.matches('dialog.mb-fx-dialog')) { e.target.close(); return; }
    var acc = e.target.closest('[data-mb-fx-acc]');
    if (acc) {
      e.preventDefault();
      var det = $$('.pdp-info details.pdp-acc').filter(function (d) { return /troca/i.test((d.querySelector('summary') || {}).textContent || ''); })[0];
      if (det) { det.open = true; det.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      return;
    }
    var go = e.target.closest('[data-mb-fx-go]');
    if (go) {
      e.preventDefault();
      var picker = $('.pdp-info [data-opt-input]');
      var box = picker && (picker.closest('fieldset') || picker);
      if (box) box.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });

  /* ---------- número vindo do anúncio (?variant=) ---------- */
  (function () {
    var vid = new URLSearchParams(location.search).get('variant');
    var note = $('[data-mb-fx-varnote]');
    if (!vid || !note) return;
    var meta = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product;
    var get = meta && meta.variants ? Promise.resolve(meta.variants) : fetch(location.pathname.replace(/\/$/, '') + '.js').then(function (r) { return r.json(); }).then(function (p) { return p.variants; });
    get.then(function (vars) {
      var v = (vars || []).filter(function (x) { return String(x.id) === String(vid); })[0];
      if (!v) return;
      var size = v.public_title || v.option1 || v.title;
      var input = $$('.pdp-info input[data-opt-input]').filter(function (i) { return i.value === size; })[0];
      if (!input) return;
      if (!input.checked) { (input.closest('label') || input).click(); }
      note.textContent = 'Você veio do anúncio do nº ' + size + ': ele já está marcado. Quer outro? É só trocar.';
      note.hidden = false;
    }).catch(function () {});
  })();

  /* ---------- botão: "Comprar · 42 · chega até …" ---------- */
  (function () {
    var btn = $('.pdp-info [data-buy]');
    if (!btn) return;
    var base = btn.dataset.buyLabel || 'Comprar';
    var arrival = '';
    function apply() {
      var t = btn.textContent.trim();
      if (btn.disabled || t.indexOf(base) !== 0) return;
      var size = ($('.pdp-info input[data-opt-input]:checked') || {}).value;
      var want = base + (size ? ' · ' + size : '') + (arrival ? ' · chega até ' + arrival : '');
      if (t !== want) btn.textContent = want;
    }
    new MutationObserver(apply).observe(btn, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
    document.addEventListener('mb-fx:quote', function (e) { arrival = e.detail && e.detail.label || ''; apply(); });
    document.addEventListener('change', function (e) { if (e.target.matches && e.target.matches('input[data-opt-input]')) setTimeout(apply, 0); });
  })();

  /* ---------- barra fixa: Pix e garantias ---------- */
  (function () {
    var t = $('.sticky-atc .sticky-atc-t');
    if (!t || $('.mb-fx-sticky', t)) return;
    var wrap = document.createElement('span'); wrap.className = 'mb-fx-sticky';
    var pix = document.createElement('b'); pix.setAttribute('data-mb-fx-sticky-pix', ''); pix.hidden = true;
    var g = document.createElement('span'); g.textContent = '↺ 1ª troca grátis · ⛨ 90 dias';
    wrap.append(pix, g); t.append(wrap);
  })();

  /* ---------- vídeo do anúncio como 2ª mídia ---------- */
  (function () {
    var tpl = $('template[data-mb-fx-video]');
    var thumbs = $('.pdp-thumbs');
    var stage = $('.pdp-main-img');
    if (!tpl || !thumbs || !stage) return;
    var src = tpl.dataset.src || '';
    var isVideo = !!(src || tpl.dataset.title);
    var btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'mb-fx-vthumb' + (src ? ' is-video' : isVideo ? '' : ' photo'); btn.setAttribute('aria-label', src ? 'Vídeo do produto' : isVideo ? 'Vídeo do anúncio' : 'Imagem do tênis na trilha');
    var im = document.createElement('img'); im.src = tpl.dataset.poster; im.alt = ''; im.width = 200; im.height = 200; im.loading = 'lazy';
    var pl = document.createElement('span'); pl.className = 'pdp-thumb-play'; pl.setAttribute('aria-hidden', 'true'); pl.textContent = '▶';
    btn.append(im);
    if (isVideo) btn.append(pl);
    var first = thumbs.children[0];
    thumbs.insertBefore(btn, first ? first.nextSibling : null);
    var ov = document.createElement('div'); ov.className = 'mb-fx-vid'; ov.hidden = true;
    var vid = null;
    if (src) {
      /* vídeo de verdade: toca no quadro principal, com controles; só baixa quando a pessoa abre */
      ov.classList.add('has-video');
      vid = document.createElement('video');
      vid.src = src; vid.poster = tpl.dataset.poster; vid.controls = true; vid.playsInline = true; vid.preload = 'none';
      vid.setAttribute('playsinline', '');
      ov.append(vid);
    } else ov.style.backgroundImage = (isVideo ? 'linear-gradient(180deg,rgba(10,14,10,.15),rgba(10,14,10,.72)),' : '') + 'url("' + tpl.dataset.poster + '")';
    var inner = document.createElement('div');
    var play = document.createElement('div'); play.className = 'mb-fx-vid-play'; play.textContent = '▶';
    var h = document.createElement('h3'); h.textContent = tpl.dataset.title || 'O vídeo do anúncio';
    var p = document.createElement('p'); p.textContent = tpl.dataset.text || '';
    if (isVideo && !src) inner.append(play, h, p);
    if (tpl.dataset.tbc) { var tb = document.createElement('p'); tb.className = 'mb-fx-small'; tb.innerHTML = '<span class="mb-tbc">A CONFIRMAR</span> '; var em = document.createElement('em'); em.className = 'mb-tbc-t'; em.textContent = tpl.dataset.tbc; tb.append(em); inner.append(tb); }
    ov.append(inner);
    ov.addEventListener('click', function (e) { e.stopPropagation(); });
    stage.append(ov);
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      $$('button', thumbs).forEach(function (b) { b.classList.toggle('cur', b === btn); });
      ov.hidden = false;
      if (vid) { var pr = vid.play(); if (pr && pr.catch) pr.catch(function () {}); }
    });
    thumbs.addEventListener('click', function (e) { var b = e.target.closest('button'); if (b && b !== btn) { ov.hidden = true; if (vid) vid.pause(); } }, true);
    /* quem chega pelo anúncio UGC (utm_content com "ugc") abre direto no vídeo */
    if (/[?&]utm_content=[^&]*ugc/i.test(location.search)) btn.click();
  })();

  /* ---------- 26/10: "Você economiza R$ X" ao lado do preço riscado ---------- */
  (function () {
    var cfg = $('template[data-mb-fx-save]');
    var box = $('.pdp-price');
    if (!cfg || !box) return;
    var pEl = $('[data-price]', box), cEl = $('[data-compare]', box);
    if (!pEl || !cEl) return;
    var cents = function (el) { var d = String(el.textContent || '').replace(/\D/g, ''); return d ? Number(d) : 0; };
    var tag = document.createElement('span');
    tag.className = 'mb-fx-save';
    tag.hidden = true;
    cEl.insertAdjacentElement('afterend', tag);
    var update = function () {
      var p = cents(pEl), c = cents(cEl);
      var on = cEl.style.display !== 'none' && !cEl.hidden && c > p && p > 0;
      tag.hidden = !on;
      /* no celular o texto curto cabe ao lado do riscado (mb-fx.css troca um pelo outro) */
      if (!on) return;
      var l = document.createElement('span'); l.className = 'mb-fx-save-l'; l.textContent = cfg.dataset.label || 'Você economiza';
      var sh = document.createElement('span'); sh.className = 'mb-fx-save-s'; sh.textContent = 'Economize';
      tag.replaceChildren(l, sh, document.createTextNode(' ' + brl(c - p)));
    };
    update();
    var mo = new MutationObserver(update);
    [pEl, cEl].forEach(function (el) { mo.observe(el, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['style', 'hidden'] }); });
  })();

  /* ---------- v2: miniaturas no celular = 4 + "+N fotos" ---------- */
  (function () {
    var thumbs = $('.pdp-thumbs');
    if (!thumbs) return;
    var list = $$('button', thumbs);
    if (list.length <= 5) return;
    var t = list[4];
    var o = document.createElement('span'); o.className = 'mb-fx-tmore'; o.setAttribute('aria-hidden', 'true');
    o.textContent = '+' + (list.length - 4) + ' fotos';
    t.append(o);
    t.setAttribute('aria-label', (t.getAttribute('aria-label') || 'Imagem') + ' · ver mais ' + (list.length - 4) + ' fotos');
    t.addEventListener('click', function () { thumbs.classList.add('mb-fx-all'); });
  })();

  /* ---------- "Combina com": adicionar à sacola ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-mb-fx-add]');
    if (!b) return;
    var msg = b.parentElement.querySelector('[data-mb-fx-add-msg]');
    b.disabled = true;
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(b.dataset.mbFxAdd), quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw new Error('add'); return fetch('/cart.js').then(function (x) { return x.json(); }); })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        if (msg) { msg.textContent = 'Adicionado à sacola. '; var a = document.createElement('a'); a.href = '/cart'; a.textContent = 'Ver sacola'; msg.append(a); }
      })
      .catch(function () { if (msg) msg.textContent = 'Não foi possível adicionar agora. Tente de novo.'; })
      .finally(function () { b.disabled = false; });
  });

  /* foto de uso (arquivo com DSC) preenche o quadro; fotos de estúdio continuam inteiras */
  (function () {
    var img = $('.pdp-main-img [data-main-image]');
    if (!img) return;
    var fit = function () { img.classList.toggle('mb-fx-cover', /DSC|Copia_de|mb-[a-z0-9]+-f\d/i.test(img.currentSrc || img.src)); };
    fit(); new MutationObserver(fit).observe(img, { attributes: true, attributeFilter: ['src', 'srcset'] });
  })();

  /* ---------- v2: título sobre a foto de uso, contador e "Assista ao vídeo" (só com vídeo de verdade) ---------- */
  (function () {
    var stage = $('.pdp-main-img');
    if (!stage) return;
    var thumbs = $('.pdp-thumbs'), cfg = $('template[data-mb-fx-hero]'), img = $('[data-main-image]', stage);
    var hero = document.createElement('div'); hero.className = 'mb-fx-hero';
    var head = null;
    if (cfg && cfg.dataset.title) {
      head = document.createElement('div'); head.className = 'mb-fx-hero-h';
      var hb = document.createElement('b'); hb.textContent = cfg.dataset.title; head.append(hb);
      if (cfg.dataset.text) { var hs = document.createElement('span'); hs.textContent = cfg.dataset.text; head.append(hs); }
      hero.append(head);
    }
    var vt = thumbs && thumbs.querySelector('button[data-type="video"],button[data-type="external_video"],button.mb-fx-vthumb.is-video');
    var vb = null;
    if (vt) {
      vb = document.createElement('button'); vb.type = 'button'; vb.className = 'mb-fx-hero-v'; vb.textContent = '▶ Assista ao vídeo';
      vb.addEventListener('click', function (e) { e.stopPropagation(); vt.click(); });
      hero.append(vb);
    }
    var n = document.createElement('span'); n.className = 'mb-fx-hero-n'; n.setAttribute('aria-hidden', 'true');
    hero.append(n);
    stage.append(hero);
    function update() {
      var list = thumbs ? $$('button', thumbs) : [];
      var i = 0;
      list.forEach(function (b, k) { if (b.classList.contains('cur')) i = k; });
      n.hidden = list.length < 2;
      n.textContent = (i + 1) + '/' + list.length;
      if (head) head.hidden = !(i === 0 && img && img.classList.contains('mb-fx-cover'));
      if (vb) vb.hidden = i !== 0;
    }
    if (thumbs) new MutationObserver(update).observe(thumbs, { subtree: true, attributes: true, attributeFilter: ['class'] });
    if (img) new MutationObserver(update).observe(img, { attributes: true, attributeFilter: ['class'] });
    update();
  })();

  /* ---------- v2: barra fixa (preço Pix + Comprar agora) ---------- */
  (function () {
    var bar = $('[data-mb-fx-sbar]');
    if (!bar) return;
    document.body.append(bar);
    var buy = $('.pdp-info [data-buy]');
    var go = $('[data-mb-fx-sbar-buy]', bar);
    var mq = matchMedia('(max-width:900px)');
    var vis = false, past = false;
    /* celular: sempre visível, menos quando o botão principal está na tela; computador: depois de passar do botão */
    function apply() { var on = !vis && (mq.matches || past); bar.classList.toggle('show', on); bar.inert = !on; bar.setAttribute('aria-hidden', String(!on)); }
    if (buy && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { vis = es[0].isIntersecting; past = es[0].boundingClientRect.top < 0; apply(); }).observe(buy);
    } else { bar.classList.add('show'); }
    apply();
    if (mq.addEventListener) mq.addEventListener('change', apply);
    go.addEventListener('click', function () {
      var size = $('.pdp-info input[data-opt-input]:checked');
      if (buy && !buy.disabled && size) { buy.click(); return; }
      var pills = $('.pdp-info .pdp-opt-pills') || buy;
      if (!pills) return;
      pills.scrollIntoView({ behavior: 'smooth', block: 'center' });
      pills.classList.remove('mb-fx-pulse'); void pills.offsetWidth; pills.classList.add('mb-fx-pulse');
    });
  })();

  /* ---------- v2: seções em sanfona abertas no computador, fechadas no celular ---------- */
  (function () {
    var accs = $$('[data-mb-fx-fold]');
    if (!accs.length) return;
    var mq = matchMedia('(min-width:901px)');
    function set() { accs.forEach(function (d) { d.open = mq.matches; }); }
    set();
    if (mq.addEventListener) mq.addEventListener('change', set);
  })();

  syncPrice();
})();
